import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExcellenceCoin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	fill: "none",
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#4dd0e1",
			d: "M34.132 20c0-7.833-6.35-14.184-14.183-14.184S5.765 12.166 5.765 20s6.35 14.183 14.184 14.183S34.132 27.833 34.132 20m1.83 0c0 8.844-7.17 16.014-16.013 16.014S3.935 28.844 3.935 20 11.105 3.986 19.95 3.986 35.962 11.156 35.962 20"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 14.641,
			fill: "#4dd0e1"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "a",
			width: 30,
			height: 30,
			x: 5,
			y: 5,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 20,
				cy: 20,
				r: 14.641,
				fill: "#4dd0e1",
				transform: "rotate(60 20 20)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#a)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#84ffff",
				d: "m10 30.808-1.01-1.154a14.7 14.7 0 0 1-1.67-2.334 14.7 14.7 0 0 1-1.186-2.612l-.495-1.451 2.904-.99.494 1.452c.24.704.552 1.397.94 2.068s.83 1.288 1.32 1.848l1.01 1.153zm2.68-23.487a14.7 14.7 0 0 1 2.612-1.187l1.451-.494.99 2.903-1.452.494-.132.046a11.6 11.6 0 0 0-3.784 2.215l-1.154 1.01L9.191 10l1.155-1.01a14.7 14.7 0 0 1 2.333-1.67m12.028 26.545-1.452.494-.988-2.903 1.451-.494zm1.079-3.843a11.6 11.6 0 0 0 1.847-1.32l2.02 2.307a14.7 14.7 0 0 1-4.946 2.856l-.989-2.903c.704-.24 1.397-.552 2.068-.94m3.867.987-2.02-2.308 1.154-1.01L30.808 30zm3.025-18.33c.488.845.883 1.72 1.187 2.612l.494 1.452-2.903.988-.494-1.451-.046-.132a11.6 11.6 0 0 0-.894-1.936 11.6 11.6 0 0 0-1.32-1.847l-1.01-1.155L30 9.192l1.01 1.155a14.7 14.7 0 0 1 1.67 2.334"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "M28.316 19.773q0 .963-.125 1.733H15.448q.158 1.925 1.322 3.016 1.164 1.092 2.863 1.091 2.454 0 3.492-2.15h4.75q-.754 2.568-2.894 4.236-2.139 1.637-5.254 1.637-2.517 0-4.53-1.124-1.983-1.155-3.115-3.24-1.101-2.087-1.101-4.814 0-2.76 1.101-4.846t3.083-3.208 4.562-1.123q2.486 0 4.436 1.09a7.46 7.46 0 0 1 3.052 3.113q1.101 1.99 1.101 4.589m-4.562-1.284q-.03-1.733-1.227-2.76-1.195-1.058-2.926-1.058-1.635 0-2.768 1.027-1.101.994-1.353 2.791z"
		})
	]
});
export default SvgExcellenceCoin;
